<template>
	<div v-if="metrics !== null">
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="Dashboard" to="/dashboard"/>
			<b-breadcrumb-item :text="metrics.server.name" :active="true"/>
		</b-breadcrumb>
		<b-container fluid v-if="metrics !== null">
			<b-row>
				<b-col lg="6" md="6" sm="12" xs="12" class="mt-2 mb-2">
					<collapsible-card title="Server Info" :visible=true>
						<table class="table table-striped table-hover table-bordered">
							<tbody>
								<tr>
									<td>Name</td>
									<td>{{metrics.server.name}}</td>
								</tr>
								<tr>
									<td>Hostname</td>
									<td>{{metrics.server.hostname}}</td>
								</tr>
								<tr>
									<td>Group</td>
									<td>{{metrics.server.group}}</td>
								</tr>
							</tbody>
						</table>
						<table class="table table-striped table-hover table-bordered">
							<thead>
								<tr>
									<th></th>
									<th class="text-center">Free</th>
									<th class="text-center">Used</th>
									<th class="text-center">Total</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>CPU</td>
									<td align="right">{{metrics.current.cpu.idle | percentage}}</td>
									<td align="right">{{metrics.current.cpu.usage | percentage}}</td>
									<td></td>
								</tr>
								<tr>
									<td>RAM</td>
									<td align="right">{{metrics.current.memory.free| size}}</td>
									<td align="right">{{metrics.current.memory.used| size}}</td>
									<td align="right">{{metrics.current.memory.free + metrics.current.memory.used | size}}</td>
								</tr>
								<tr>
									<td>Swap</td>
									<td align="right">{{metrics.current.swap.free| size}}</td>
									<td align="right">{{metrics.current.swap.used| size}}</td>
									<td align="right">{{metrics.current.swap.free + metrics.current.swap.used | size}}</td>
								</tr>
								<tr>
									<td>Disk</td>
									<td align="right">{{metrics.current.disk.free | size}}</td>
									<td align="right">{{metrics.current.disk.used | size}}</td>
									<td align="right">{{metrics.current.disk.free + metrics.current.disk.used | size}}</td>
								</tr>
							</tbody>
						</table>
					</collapsible-card>
				</b-col>
				<b-col lg="6" md="6" sm="12" xs="12" class="mt-2 mb-2">
					<b-card header-tag="header" footer-tag="footer">
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Server Status</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="server" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<bar-chart ref="summaryChart" :chartData="summary.chartData" :options="summary.chartOptions" :height="375"></bar-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="3" md="3" sm="6" xs="12" class="mt-2 mb-2">
					<b-card header-tag="header" footer-tag="footer">
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">CPU</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="microchip" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<!-- 
							<h1 class="text-center">{{metrics.current.cpu.usage | percentage}}</h1>
							 -->
							<doughnut-chart ref="cpuPieChart" :chartData="cpu.pie.chartData" :options="cpu.pie.chartOptions"></doughnut-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="9" md="9" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">CPU Trend</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="microchip" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="cpuTrendChart" :chartData="cpu.trend.chartData" :options="cpu.trend.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="3" md="3" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Memory</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="memory" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<!-- 
							<h1 class="text-center">{{metrics.current.memory.usage | percentage}}</h1>
							 -->
							<doughnut-chart ref="memoryPieChart" :chartData="memory.pie.chartData" :options="memory.pie.chartOptions"></doughnut-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="9" md="9" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Memory</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="memory" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="memoryTrendChart" :chartData="memory.trend.chartData" :options="memory.trend.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="3" md="3" sm="6" xs="12" class="mt-2 mb-2">
					<b-card ref="memory">
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Swap</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="memory" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<!-- 
							<h1 class="text-center">{{metrics.current.swap.usage | percentage}}</h1>
							 -->
							<doughnut-chart ref="swapPieChart" :chartData="swap.pie.chartData" :options="swap.pie.chartOptions"></doughnut-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="9" md="9" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Swap</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="memory" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="swapTrendChart" :chartData="swap.trend.chartData" :options="swap.trend.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="3" md="3" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Disk</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="hdd" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<!-- 
								<h1 class="text-center">{{metrics.current.disk.usage | percentage}}</h1>
							 -->
							<doughnut-chart ref="disksPieChart" :chartData="disks.pie.chartData" :options="disks.pie.chartOptions"></doughnut-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="9" md="9" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Disk</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="hdd" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="disksTrendChart" :chartData="disks.trend.chartData" :options="disks.trend.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Disk Activity</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="hdd" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="disksActivityTrendChart" :chartData="disks.activity.chartData" :options="disks.activity.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<template v-slot:header>
							<b-row>
								<b-col cols="9"><h4 class="card-title">Network Activity</h4></b-col>
								<b-col cols="3" class="text-right"><icon name="network-wired" scale="1"></icon></b-col>
							</b-row>
						</template>
						<b-card-text>
							<line-chart ref="networkTrendChart" :chartData="network.chartData" :options="network.chartOptions"></line-chart>
						</b-card-text>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import {HTTP} from '../../services/HttpService'
import DoughnutChart from '../../components/DoughnutChart.vue'
import BarChart from '../../components/BarChart.vue'
import LineChart from '../../components/LineChart.vue'
import CollapsibleCard from '../../components/CollapsibleCard.vue'

export default {
  components: {
    DoughnutChart,
    BarChart,
    LineChart,
    CollapsibleCard
  },
  name: 'monitor',
  data: () => ({
    metrics: null,
    refreshInterval: null,
    summary: {
      chartData: {
        labels: ['CPU', 'Memory', 'Swap', 'Disk'],
        datasets: [ {
          backgroundColor: ['#9fcdff', '#f1b0b7', '#b1dfbb', '#ffe8a1'],
          borderColor: ['#9fcdff', '#f1b0b7', '#b1dfbb', '#ffe8a1'],
          data: [0, 0, 0, 0]
        }]
      },
      chartOptions: {
        legend: {
          display: false
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 100
            }
          }]
        }
      }
    },
    cpu: {
      pie: {
        chartData: {
          text: '123',
          labels: ['User', 'System', 'Idle'],
          datasets: [ {
            backgroundColor: ['#9fcdff', '#f1b0b7', '#EEEEEE'],
            borderColor: ['#9fcdff', '#f1b0b7', '#EEEEEE'],
            data: [0, 0, 100]
          }]
        },
        chartOptions: {
        }
      },
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#9fcdff',
            borderColor: '#9fcdff',
            data: []
          }, {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      }
    },
    memory: {
      pie: {
        chartData: {
          labels: ['Used', 'Free'],
          datasets: [ {
            backgroundColor: ['#f1b0b7', '#EEEEEE'],
            borderColor: ['#f1b0b7', '#EEEEEE'],
            data: [0, 100]
          }]
        },
        chartOptions: {
        }
      },
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      }
    },
    swap: {
      pie: {
        chartData: {
          labels: ['Used', 'Free'],
          datasets: [ {
            backgroundColor: ['#f1b0b7', '#EEEEEE'],
            borderColor: ['#f1b0b7', '#EEEEEE'],
            data: [0, 100]
          }]
        },
        chartOptions: {
        }
      },
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      }
    },
    disks: {
      pie: {
        chartData: {
          labels: ['Used', 'Free'],
          datasets: [ {
            backgroundColor: ['#f1b0b7', '#EEEEEE'],
            borderColor: ['#f1b0b7', '#EEEEEE'],
            data: [0, 100]
          }]
        },
        chartOptions: {
        }
      },
      trend: {
        chartData: {
          labels: [],
          datasets: [ {
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                max: 100
              }
            }]
          }
        }
      },
      activity: {
        chartData: {
          labels: [],
          datasets: [ {
            label: 'Reads',
            fill: true,
            backgroundColor: '#9fcdff',
            borderColor: '#9fcdff',
            data: []
          }, {
            label: 'Writes',
            fill: true,
            backgroundColor: '#f1b0b7',
            borderColor: '#f1b0b7',
            data: []
          }]
        },
        chartOptions: {
          animation: {
            duration: 0
          },
          legend: {
            display: true
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                suggestedMin: -5242880,
                suggestedMax: 5242880,
                callback: function (value, index, values) {
                  var max = Math.abs(value)
                  var divisor = 1
                  var suffix = ''
                  if (max > 1048576) {
                    divisor = 1048576
                    suffix = ' mb'
                  } else if (max > 1024) {
                    divisor = 1024
                    suffix = ' kb'
                  }
                  return (Math.abs(value) / divisor).toFixed(2) + suffix
                }
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }]
          }
        }
      }
    },
    network: {
      chartData: {
        labels: [],
        datasets: [ {
          label: 'Received',
          fill: true,
          backgroundColor: '#9fcdff',
          borderColor: '#9fcdff',
          data: []
        }, {
          label: 'Sent',
          fill: true,
          backgroundColor: '#f1b0b7',
          borderColor: '#f1b0b7',
          data: []
        }]
      },
      chartOptions: {
        animation: {
          duration: 0
        },
        legend: {
          display: true
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              suggestedMin: -1048576,
              suggestedMax: 1048576,
              callback: function (value, index, values) {
                var max = Math.abs(value)
                var divisor = 1
                var suffix = ''
                if (max > 1048576) {
                  divisor = 1048576
                  suffix = ' mb'
                } else if (max > 1024) {
                  divisor = 1024
                  suffix = ' kb'
                }
                return (Math.abs(value) / divisor).toFixed(2) + suffix
              }
            },
            scaleLabel: {
              display: true,
              labelString: ''
            }
          }]
        }
      }
    }
  }),
  methods: {
    updateData () {
      HTTP.get('dashboard/' + this.$route.params.serverId)
        .then(response => {
          this.metrics = response.data
          // Update the summary chart data
          this.summary.chartData.datasets[0].data[0] = this.metrics.current.cpu.usage
          this.summary.chartData.datasets[0].data[1] = this.metrics.current.memory.usage
          this.summary.chartData.datasets[0].data[2] = this.metrics.current.swap.usage
          this.summary.chartData.datasets[0].data[3] = this.metrics.current.disk.usage
          // this.summary.chart.updateChart()
          this.$refs.summaryChart.updateChart()

          var labels = []
          var cpuUserTrend = []
          var cpuSystemTrend = []
          var memoryUsageTrend = []
          var swapUsageTrend = []
          var diskUsageTrend = []
          var diskReadsTrend = []
          var diskWritesTrend = []
          var networkReadsTrend = []
          var networkWritesTrend = []
          for (var i in this.metrics.metrics) {
            labels.push('')
            cpuUserTrend.push(this.metrics.metrics[i].cpu.user)
            cpuSystemTrend.push(this.metrics.metrics[i].cpu.system + this.metrics.metrics[i].cpu.user)
            memoryUsageTrend.push(this.metrics.metrics[i].memory.usage)
            swapUsageTrend.push(this.metrics.metrics[i].swap.usage)
            diskUsageTrend.push(this.metrics.metrics[i].disk.usage)
            diskReadsTrend.push(this.metrics.metrics[i].disk.reads)
            diskWritesTrend.push(-this.metrics.metrics[i].disk.writes)
            networkReadsTrend.push(this.metrics.metrics[i].network.receivedBytes)
            networkWritesTrend.push(-this.metrics.metrics[i].network.sentBytes)
          }
          // update cpu pie chart data
          this.cpu.pie.chartData.text = this.$filters.percentage(this.metrics.current.cpu.usage)
          this.cpu.pie.chartData.datasets[0].data[0] = this.metrics.current.cpu.user
          this.cpu.pie.chartData.datasets[0].data[1] = this.metrics.current.cpu.system
          this.cpu.pie.chartData.datasets[0].data[2] = this.metrics.current.cpu.idle
          this.$refs.cpuPieChart.updateChart()

          // update cpu trend data
          this.cpu.trend.chartData.labels = labels
          this.cpu.trend.chartData.datasets[0].data = cpuUserTrend
          this.cpu.trend.chartData.datasets[1].data = cpuSystemTrend
          this.$refs.cpuTrendChart.updateChart()

          // update memory pie chart data
          this.memory.pie.chartData.text = this.$filters.percentage(this.metrics.current.memory.usage)
          this.memory.pie.chartData.datasets[0].data[0] = this.metrics.current.memory.used
          this.memory.pie.chartData.datasets[0].data[1] = this.metrics.current.memory.free
          this.$refs.memoryPieChart.updateChart()

          // update memory trend data
          this.memory.trend.chartData.labels = labels
          this.memory.trend.chartData.datasets[0].data = memoryUsageTrend
          this.$refs.memoryTrendChart.updateChart()

          // update swap pie chart data
          this.swap.pie.chartData.text = this.$filters.percentage(this.metrics.current.swap.usage)
          this.swap.pie.chartData.datasets[0].data[0] = this.metrics.current.swap.used
          this.swap.pie.chartData.datasets[0].data[1] = this.metrics.current.swap.free
          this.$refs.swapPieChart.updateChart()

          // update swap trend data
          this.swap.trend.chartData.labels = labels
          this.swap.trend.chartData.datasets[0].data = swapUsageTrend
          this.$refs.swapTrendChart.updateChart()

          // update disk pie chart data
          this.disks.pie.chartData.text = this.$filters.percentage(this.metrics.current.disk.usage)
          this.disks.pie.chartData.datasets[0].data[0] = this.metrics.current.disk.used
          this.disks.pie.chartData.datasets[0].data[1] = this.metrics.current.disk.free
          this.$refs.disksPieChart.updateChart()

          // update disk trend chart data
          this.disks.trend.chartData.labels = labels
          this.disks.trend.chartData.datasets[0].data = diskUsageTrend
          this.$refs.disksTrendChart.updateChart()

          // update disk activity trend chart data
          this.disks.activity.chartData.labels = labels
          this.disks.activity.chartData.datasets[0].data = diskReadsTrend
          this.disks.activity.chartData.datasets[1].data = diskWritesTrend
          this.$refs.disksActivityTrendChart.updateChart()

          // update network trend chart data
          this.network.chartData.labels = labels
          this.network.chartData.datasets[0].data = networkReadsTrend
          this.network.chartData.datasets[1].data = networkWritesTrend
          this.$refs.networkTrendChart.updateChart()
        })
    }
  },
  created () {
    this.updateData()
    this.refreshInterval = setInterval(this.updateData, 1000)
  },
  destroyed () {
    console.log('destroyed')
    clearInterval(this.refreshInterval)
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// ServerDashboardPage.vue?37d494d3